"use client"

import * as React from "react"

/**
 * Radix UI の既知問題対策。
 *
 * DropdownMenu の項目クリックから Dialog / AlertDialog を開閉すると、
 * モーダルレイヤーの参照カウントがずれて body の pointer-events: none が
 * 残留し、リロードするまでページ全体が操作不能になることがある。
 * （一覧画面の「…」メニュー → 削除確認 → 削除実行 の流れで発生）
 *
 * モーダルコンテンツのアンマウント時に、開いているモーダルが他に無ければ
 * 残留した pointer-events を解除する。Radix 自身の後処理より後に走らせる
 * ため 1 tick 遅延させる。
 */
export function useModalPointerEventsCleanup() {
  React.useEffect(() => {
    return () => {
      setTimeout(() => {
        const anyModalOpen = document.querySelector(
          '[data-state="open"][role="dialog"], [data-state="open"][role="alertdialog"]'
        )
        if (!anyModalOpen && document.body.style.pointerEvents === "none") {
          document.body.style.pointerEvents = ""
        }
      }, 0)
    }
  }, [])
}
